import { render, staticRenderFns } from "./AbnormalSummaryTable.vue?vue&type=template&id=4981c1b4&scoped=true&"
import script from "./AbnormalSummaryTable.vue?vue&type=script&lang=js&"
export * from "./AbnormalSummaryTable.vue?vue&type=script&lang=js&"
import style0 from "./AbnormalSummaryTable.vue?vue&type=style&index=0&id=4981c1b4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4981c1b4",
  null
  
)

export default component.exports